module.exports = __webpack_public_path__ + "img/Help-icon.331cd035.svg";